import { DefaultElementPreviewFragment } from "@/core/graphql/graphql";
import { Component, Input } from "@angular/core";

@Component({
  templateUrl: './default-element-preview.component.html',
  selector: 'cosmos-default-element-preview',
  styleUrls: ['./default-element-preview.component.scss'],
})
export class DefaultElementPreviewComponent {
  @Input() public isCompact = true;
  @Input() public set element (element: DefaultElementPreviewFragment) {
    this._element = element;
    this.text = element.text || '';
  }
  public _element: DefaultElementPreviewFragment;
  public text: string;
}
